export const ACCESS_TOKEN = 'Access-Token'
export const USER_NAME = 'USER_NAME'
export const NAME = 'NAME'
export const USER_ID = 'USER_ID'
export const USER_COMPANY_NAME = 'USER_COMPANY_NAME'
export const USER_ROLES = 'USER_ROLES'
export const AUDIT_STATUS = 'AUDIT_STATUS'
export const APPLY_INFO = 'APPLY_INFO'
export const HOUSE_INFO = 'HOUSE_INFO'
export const MENU_ACTIVE = 'MENU_ACTIVE'
export const IS_MONITORING = 'IS_MONITORING'
